export default "__VITE_ASSET__Wzg7YDSG__"